/**
 * @file MemberInbox.jsx
 * @location src/components/mypage/MemberInbox.jsx
 * @role 팀원 화면 최상단 「업무도착」 — 매니저가 할당한 안 읽음 업무 surfacing.
 *   각 행 오른쪽 확인 버튼 → ACK_TASK(읽음) → 표(담당업무)로 들어감.
 *   설명(note) 있으면 확인 시 모달로 설명 표시 후 확인(없으면 바로 읽음). 안 읽음 0건이면 렌더 안 함.
 */
import { useState } from 'react';
import { useApp } from '../../store/AppContext';
import { useMembers } from '../../store/useMembers';
import { DueText } from '../ui/SharedUI';
import { Icon } from '../ui/Icon';
import { ArrivedTaskModal } from './ArrivedTaskModal';

/**
 * @param {object} props
 * @param {import('../../data/types.js').Task[]} props.unread  안 읽음(미열람·미완) task — getAttentionBuckets().unack
 */
export function MemberInbox({ unread }) {
  const { act } = useApp();
  const { mname } = useMembers();
  const [detailTask, setDetailTask] = useState(null);
  if (!unread?.length) return null;

  const ack = (id) => act('ACK_TASK', { id });
  // 확인 클릭 — 설명 있으면 상세 모달로 보여주고(모달 안 확인으로 읽음), 없으면 즉시 읽음.
  const onConfirm = (t) => (t.note?.trim() ? setDetailTask(t) : ack(t.id));

  return (
    <div className="member-inbox">
      <div className="member-inbox-head">
        <span className="member-inbox-bell"><Icon name="bell" size={15} /></span>
        업무 도착
        <span className="cnt">{unread.length}</span>
        <span className="member-inbox-hint">확인하면 업무 리스트로 들어갑니다</span>
      </div>
      <ul className="member-inbox-list">
        {unread.map(t => (
          <li key={t.id} className="member-inbox-item">
            <Icon name="mail" size={14} />
            <button type="button" className="member-inbox-title" onClick={() => setDetailTask(t)} title="상세 보기">
              {t.title}
            </button>
            {t.note?.trim() && <Icon name="document" size={12} className="member-inbox-note" />}
            <span className="member-inbox-from">{mname(t.aor)}</span>
            <DueText due={t.due} status={t.status} dateKind={t.dateKind} />
            <button type="button" className="btnp member-inbox-confirm" onClick={() => onConfirm(t)}>확인</button>
          </li>
        ))}
      </ul>
      {detailTask && <ArrivedTaskModal task={detailTask} onClose={() => setDetailTask(null)} />}
    </div>
  );
}
